import { FC } from 'react';

import {
	EmptyStateDescriptionStyled,
	EmptyStateHeadingStyled,
	EmptyStateImageStyled,
	EmptyStateStyled,
} from './EmptyState.styles';

interface Props {
	heading: string;
	description: string;
	image: string;
}

export const EmptyState: FC<Props> = ({ heading, description, image }) => (
	<EmptyStateStyled>
		<EmptyStateImageStyled src={image} />
		<EmptyStateHeadingStyled>{heading}</EmptyStateHeadingStyled>
		<EmptyStateDescriptionStyled>{description}</EmptyStateDescriptionStyled>
	</EmptyStateStyled>
);
